/**
 * HistoryTabContent
 * History tab showing issue activity timeline
 */

import type { IssueDetails } from '../../../../domain'
import { HistoryTimeline } from '../panels'
import { FeedbackLink, TabContentLayout } from '../shared'

export interface HistoryTabContentProps {
  issue: IssueDetails
}

export function HistoryTabContent({ issue }: HistoryTabContentProps) {
  const history = issue.history || []

  return (
    <TabContentLayout>
      <HistoryTimeline entries={history} title="Issue History" />
      <FeedbackLink context="history" />
    </TabContentLayout>
  )
}
